import Hero from "./../component/Hero";
import Intro from "../component/Introduce";
import Footer from "../component/Footer";

export default function Home() {
  return (
    <div>
      <Hero></Hero>

      <Intro></Intro>

      <Footer></Footer>
    </div>
  );
}
